/*
 * @Author: mayanxia 
 * @Date: 2020-12-29 11:43:57 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-02-04 11:58:22
 */
/* 运营分析 */
<template>
    <div class="index-main">
        <a-row style="height: 100%;positive: relative">
            <a-col :span="6" class="cell-left">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 33%">
                        <water-use-analysis ref="waterUse" :titleImage="titleImage"></water-use-analysis>
                    </a-col>
                    <a-col :span="24" style="height: 35%">
                      <UsersNumberAndWaterType ref="UsersNumberAndWaterTypeRef" />
                        <!-- <fault-analysis ref="faultCount" :titleImage="titleImage"></fault-analysis> -->
                    </a-col>
                    <a-col :span="24" style="height: 32%">
                      <water-use-of-type-analysis ref="waterUseOfType" :titleImage="titleImage"></water-use-of-type-analysis>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="12" style="height: 100%;">
                <a-row style="height: 70%;margin-left: 5px;margin-right: 5px">
                    <a-col :span="24" style="height: 100%;position: relative">
                        <div style="position: absolute;top: 30px;left: 50%;transform: translateX(-50%);z-index: 99">
                            <top-header ref="toHeaderCount"></top-header>
                        </div>
                        <!-- <echart-map :titleImage="titleImage"></echart-map> -->
                        <businessCenter></businessCenter>
                    </a-col>
                </a-row>
                <a-row  class="cell-bottom" style="height: 30%;margin-left: 5px;margin-right: 5px">
                    <a-col :span="24" style="height: 100%">
                        <water-use-of-year-analysis ref="waterUseOfYear" :titleImage="titleImage"></water-use-of-year-analysis>
                    </a-col>
                        
                </a-row>
            </a-col>
            <a-col :span="6" class="cell-right">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 32%">
                        <water-pay-diff-analysis ref="waterPayDiff" :titleImage="titleImage"></water-pay-diff-analysis>
                    </a-col>
                    <a-col :span="24" style="height: 34%">
                      <AnnualAccountsReceivable ref="AnnualAccountsReceivableRef" :titleImage="titleImage"/>
                        <!-- <device-analysis ref="deviceCount" :titleImage="titleImage"></device-analysis> -->
                    </a-col>
                    <a-col :span="24" style="height: 34%">
                        <water-use-and-pay-analysis ref="waterUseAndPay" :titleImage="titleImage"></water-use-and-pay-analysis>
                    </a-col>
                    
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>
<script>
import waterUseAnalysis from './modules/waterUseAnalysis'
import faultAnalysis from './modules/faultAnalysis'
import deviceAnalysis from './modules/deviceAnalysis'
import waterUseOfYearAnalysis from './modules/waterUseOfYearAnalysis'
import waterUseAndPayAnalysis from './modules/waterUseAndPayAnalysis'
import  waterUseOfTypeAnalysis from './modules/waterUseOfTypeAnalysis'
import waterPayDiffAnalysis from './modules/waterPayDiffAnalysis'
// import echartMap from './modules/echartMap'
import topHeader from './modules/topHeader'
import businessCenter from './modules/businessCenter'
import UsersNumberAndWaterType from './modules/UsersNumberAndWaterType'
import AnnualAccountsReceivable from './modules/AnnualAccountsReceivable'
export default {
    components: {
        waterUseAnalysis,
        faultAnalysis,
        deviceAnalysis,
        waterUseOfYearAnalysis,
        waterUseAndPayAnalysis,
        waterUseOfTypeAnalysis,
        waterPayDiffAnalysis,
        businessCenter,
        topHeader,
        UsersNumberAndWaterType,
        AnnualAccountsReceivable
    },
    data() {
        return {
            titleImage:require("@/assets/images/title-gradual.png"),
        }
    },
    mounted() {
        this.$nextTick(()=> {
            this.init()
        })
    },
    methods: {
        init() {
            this.$refs.toHeaderCount.init()
            this.$refs.waterUse.init()
            // this.$refs.faultCount.init()
            // this.$refs.deviceCount.init()
            this.$refs.waterUseOfType.init()
            this.$refs.waterUseAndPay.init()
            this.$refs.waterUseOfYear.init()
            this.$refs.waterPayDiff.init()
            this.$refs.UsersNumberAndWaterTypeRef.init()
            this.$refs.AnnualAccountsReceivableRef.init()
        }
    }
}
</script>
<style lang="less" scoped>
.index-main{
    height: 100%;
    padding: 12px;
}
.cell-left,.cell-right{
    height: 100%;
    padding-left: 12px;
    padding-right: 12px;
    //position: absolute;
}
.cell-bottom{
    height: 30%;
    //position: absolute;
    background: url('~@/assets/images/cell-bottom.png') no-repeat;
    background-size: 100% 100%;
}
.cell-left{
    top: 0;
    left: 0;
}
.cell-right{
    top: 0;
    right: 0;
}
.cell-bottom{
    bottom: 0;
    height: 30%;
}
/* 每块内容的样式 */
.index-main{
    /deep/ .m-panel{
        color: #B6DEFF;
        height: 100%;
    }
    /deep/ .m-panel-bar{
        height: 40px;
    }
    /deep/ .m-panel-bar-title{
        font-size: 18px;
        font-weight: 700;
        color: #B6DEFF;
        display: flex;
        align-items: center;
        padding-left: 7px;
        border-bottom: 5px solid transparent; /* 创建透明的下边框 */
        border-image: url('~@/assets/images/title-gradual.png') 5 stretch; /* 指定图像路径、重复次数和对齐方式 */
        border-image-repeat: stretch;
    }
    /deep/ .m-panel-body{
        height: calc(100% - 40px)
    }
    /deep/ .total-sum{
        color: #A8C6F3;
        font-weight: bold;
        font-size: 33px;
        margin-top: 33px;
    }
    /deep/ .unit{
        font-size: 12px;
        color: #A8C6F3;
        margin-left: 5px;
    }
    /deep/ .m-total{
        padding: 10px;
        line-height: 1;
        
        .total-title{
            color: #01B8FD;
            font-weight: 500;
            font-size: 16px;
        }
        .total-type-title{
            color: #B6DEFF;
        }
    }
    /deep/ .font-24{
        font-size: 24px;
    }
    /deep/ .flex-center{
        display: flex;
        align-items: center;
    }
}
.cell-left{
    position: relative;
    background: url('~@/assets/images/cell-left.png') no-repeat;
    background-size: 100% 100%;
}
.cell-right{
    position: relative;
    background: url('~@/assets/images/cell-right.png') no-repeat;
    background-size: 100% 100%;
}
</style>